const {
  LARGE_N_WARNING_TEXT,
  LARGE_N_WARNING_THRESHOLD,
  MAX_PARTICIPANTS,
  SEQUENCE_PREVIEW_LIMIT
} = require('./limits');

const APP_VERSION = 'randFlow V2 Sprint 11 security foundation';
const DEFAULT_LANGUAGE = 'pt';
const SUPPORTED_LANGUAGES = Object.freeze(['pt', 'en', 'es']);
const MIN_ARMS = 2;
const MAX_ARMS = 4;

module.exports = {
  APP_VERSION,
  DEFAULT_LANGUAGE,
  LARGE_N_WARNING_TEXT,
  LARGE_N_WARNING_THRESHOLD,
  MAX_ARMS,
  MAX_PARTICIPANTS,
  MIN_ARMS,
  SEQUENCE_PREVIEW_LIMIT,
  SUPPORTED_LANGUAGES
};
